import { FormControl, InputLabel } from '@material-ui/core';
import React from 'react';

import { currencyFormat } from 'utils/currencyFormat';
import Budget from 'entities/budget/model';
import { BudgetTotals } from 'containers/DonationRulesListPage/utils';

interface Props {
  budget: Budget;
  budgetTotals: BudgetTotals;
  budgetInactive: boolean;
}

export const DonationGivingBudgetAllocationsCorporateDonationSummary = ({
  budget,
  budgetTotals,
  budgetInactive,
}: Props) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 15,
      opacity: budgetInactive ? 0.5 : 1,
    }}
  >
    <div style={{ width: '20%' }}>
      <FormControl style={{ width: '100%', height: 17 }}>
        <InputLabel shrink>Used</InputLabel>
      </FormControl>
      <div>{currencyFormat(budgetTotals.totalCorporateDonations, budget.get('currencyCode'))}</div>
    </div>
    <div style={{ width: '20%' }}>
      <FormControl style={{ width: '100%', height: 17 }}>
        <InputLabel shrink>Balance</InputLabel>
      </FormControl>
      <div>
        {Number.isFinite(budgetTotals.totalCorporateDonationsAllocationBalance)
          ? currencyFormat(
              budgetTotals.totalCorporateDonationsAllocationBalance,
              budget.get('currencyCode')
            )
          : '-'}
      </div>
    </div>
    <div style={{ width: '20%' }}>
      <FormControl style={{ width: '100%', height: 17 }}>
        <InputLabel shrink>Allocated</InputLabel>
      </FormControl>
      <div>
        {currencyFormat(budgetTotals.totalCorporateDonationsAllocation, budget.get('currencyCode'))}
      </div>
    </div>
    <div style={{ width: '20%' }} />
    <div style={{ width: '20%' }}>
      <FormControl style={{ width: '100%', height: 17 }}>
        <InputLabel shrink>Donation Count</InputLabel>
      </FormControl>
      <div>{budgetTotals.corporateDonationsCount}</div>
    </div>
  </div>
);

export default DonationGivingBudgetAllocationsCorporateDonationSummary;
